import { render } from "./TelemetryGeneric.vue?vue&type=template&id=ca3a67b8"
import script from "./TelemetryGeneric.vue?vue&type=script&lang=js"
export * from "./TelemetryGeneric.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__